import { EventTrackingProvider } from "@newsela/snitch";
import PropTypes from "prop-types";

import useUser from "@/users/useUser";
import useGetPreviousUrl from "../useGetPreviousUrl";
import type { ReactNode } from "react";

const propTypes = {
  children: PropTypes.node,
};

const EventTrackingProviderSnitch = ({ children }: { children: ReactNode }) => {
  const { data: user } = useUser();
  const getPreviousUrl = useGetPreviousUrl();
  return (
    <EventTrackingProvider
      userInfo={{ userId: user?.id, uniqueUserId: user?.unique_id }}
      getPreviousUrl={getPreviousUrl}
      platform="lyceum"
    >
      {children}
    </EventTrackingProvider>
  );
};

EventTrackingProviderSnitch.propTypes = propTypes;

export default EventTrackingProviderSnitch;
